import React, { useState } from 'react'
import '../index.css'
import Logo from '../assets/logo.png'
import Accountimg from '../assets/account_icon.png'
import Active from '../assets/active.png'
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js'
import { motion } from 'framer-motion';

const DashboardHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const {logout} = useAuth();

  function goToNextPage(){
    navigate('/dashboard')
  }

  function handleLogout() {
    logout();
  }
  return (
    <header>

        <nav className="homify-nav" id="nav-bar">
            <Link to='/dashboard'>
             <img className="logo" src={Logo} alt="Homify Logo" />
            </Link>

            <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
              <motion.div
                className="line"
                animate={isOpen ? { rotate: 45, y: 7 } : { rotate: 0, y: 0 }}
                transition={{ duration: 0.3 }}
              />
              <motion.div
                className="line"
                animate={isOpen ? { opacity: 0 } : { opacity: 1 }}
                transition={{ duration: 0.3 }}
              />
              <motion.div
                className="line"
                animate={isOpen ? { rotate: -45, y: -7 } : { rotate: 0, y: 0 }}
                transition={{ duration: 0.3 }}
              />
            </div>

            
           
            <ul className={isOpen ? 'second-nav show-nav' : 'second-nav'}>
                <Link to='/dashboard/myproperties'>
                  <li  onClick={() => setIsOpen(!isOpen)} className="reg"><p className="dash-anchor" >MY PROPERTIES</p></li>
                </Link> 
                <Link to='/dashboard/topListing'>
                  <li  onClick={() => setIsOpen(!isOpen)} className="reg"><p className="dash-anchor" >TOP LISTINGS</p></li>
                </Link> 
                <Link to='/dashboard/profile' className=''>
                  <li  onClick={() => setIsOpen(!isOpen)} className="reg ash-back">
                    <p className="dash-anchor" >
                      <img src={Accountimg} alt="" className="account-img acc-img1 " />
                    </p>
                  </li>
                </Link> 
                <Link to='/dashboard/notification'>
                  <li  onClick={() => setIsOpen(!isOpen)} className="reg">
                    <p className="dash-anchor" >
                      <img src={Active} alt="" className="account-img acc-img2"/>
                    </p>
                  </li>
                </Link> 
              
                  <li  onClick={handleLogout} class="login">LOGOUT</li>
                

              
                
            
            </ul>
        </nav>  
    </header>
  )
}

export default DashboardHeader;